/**
 * Copyright © 2026 Adnuntius AS.
 */
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {AdStatusLabelComponent} from '../ad-unit/ad-status-component';
import {DimensionOutputComponent} from '../ad-unit/dimension-output-component';
import {AdvertiserStatusLabelComponent} from '../advertiser/advertiser-status-component';
import {APP_SHARED} from '../common/app-shared';
import {ADMIN_LIST} from '../common/directives/admin-list';
import {AdnSelectComponent} from '../common/directives/adn-select/adn-select.component';
import {CHARTS} from '../common/directives/charts';
import {FORM_CONTROLS} from '../common/directives/form-controls/form-controls';

export const TARGETING_IMPORTS = [
  ...APP_SHARED,
  ...ADMIN_LIST,
  FormsModule,
  TranslateModule,
  UIRouterModule,
  ButtonsModule,
  CollapseModule,
  PopoverModule,
  TabsModule,
  AdnSelectComponent,
  ...CHARTS,
  ...FORM_CONTROLS,
  AdStatusLabelComponent,
  AdvertiserStatusLabelComponent,
  DimensionOutputComponent
];
